import { action } from 'app/actions';

export const SELECT_LANGUAGE = 'lang/SELECT_LANGUAGE';

export const selectLanguage = locale => action(SELECT_LANGUAGE, { payload: locale });
